//路线新建、编辑弹窗
<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :title="getTitle"
    width="80%"
    append-to-body
  >
    <div class="dialog-content">
      <el-form :model="dialogData" :rules="rules" ref="dialogForm" label-width="150px">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="线路名" prop="routeName">
              <template v-if="ifCreateNewRoute">
                <el-input
                  v-model="dialogData.routeName"
                  placeholder="请输入线路名"
                  @change="routeNameEdit"
                ></el-input>
              </template>
              <template v-else>
                <SearchTable
                  :value="dialogData.routeName"
                  searchType="route"
                  :isMultiple="true"
                  :currentValue="dialogData.routeName"
                  @input="handleRouteChange"
                  placeholder="请选择线路名"
                >
                </SearchTable>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="departureProvinceCode" label="启运省">
              <el-select
                filterable
                v-model="dialogData.departureProvinceCode"
                @change="(value) => queryCity(value).then(() => resetLocation(0))"
                ref="startProvinceRef"
                placeholder="请选择省"
                clearable
              >
                <el-option
                  v-for="(item, index) of provinceList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 市-地区 -->
          <el-col :span="6">
            <el-form-item label="启运市" style="padding-right: 0" prop="departureCityCode">
              <el-select
                filterable
                v-model="dialogData.departureCityCode"
                @change="(value) => queryArea(value).then(() => resetLocation(1))"
                ref="startCityRef"
                placeholder="请选择市"
                clearable
              >
                <el-option
                  v-for="(item, index) of departureCityList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="启运区/县" prop="departureAreaCode">
              <el-select
                filterable
                v-model="dialogData.departureAreaCode"
                ref="startAreaRef"
                placeholder="请选择区"
                clearable
                @change="(value) => placeChange('启运区/县', value)"
              >
                <el-option
                  v-for="(item, index) of departureAreaList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="启运详细地址" prop="departurePlaceDetail">
              <el-input
                v-model="dialogData.departurePlaceDetail"
                placeholder="请输入启运详细地址"
                @change="(value) => placeChange('启运详细地址', value)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="启运位置类型" prop="departurePlaceType">
              <el-select
                v-model="dialogData.departurePlaceType"
                placeholder="请选择启运位置类型"
                @change="(value) => placeChange('启运位置类型', value)"
              >
                <el-option label="站" value="0"></el-option>
                <el-option label="堆场" value="1"></el-option>
                <el-option label="门" value="2"></el-option>
                <el-option label="码头" value="3"></el-option>
                <el-option label="港口" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="destinationProvinceCode" label="目的省">
              <el-select
                filterable
                v-model="dialogData.destinationProvinceCode"
                @change="(value) => queryCity(value, false).then(() => resetLocation(2))"
                placeholder="请选择省"
                ref="endProvinceRef"
                clearable
              >
                <el-option
                  v-for="(item, index) of provinceList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="目的市" style="padding-right: 0" prop="destinationCityCode">
              <el-select
                filterable
                v-model="dialogData.destinationCityCode"
                @change="(value) => queryArea(value, false).then(() => resetLocation(3))"
                ref="endCityRef"
                placeholder="请选择市"
                clearable
              >
                <el-option
                  v-for="(item, index) of destinationCityList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="目的区/县" prop="destinationAreaCode">
              <el-select
                filterable
                v-model="dialogData.destinationAreaCode"
                ref="endAreaRef"
                placeholder="请选择区"
                clearable
                @change="(value) => placeChange('目的区/县', value)"
              >
                <el-option
                  v-for="(item, index) of destinationAreaList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="目的详细地址" prop="destinationDetail">
              <el-input
                v-model="dialogData.destinationDetail"
                placeholder="请输入目的详细地址"
                @change="(value) => placeChange('目的详细地址', value)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="目的位置类型" prop="destinationType">
              <el-select
                v-model="dialogData.destinationType"
                placeholder="请选择目的位置类型"
                @change="(value) => placeChange('目的位置类型', value)"
              >
                <el-option label="站" value="0"></el-option>
                <el-option label="堆场" value="1"></el-option>
                <el-option label="门" value="2"></el-option>
                <el-option label="码头" value="3"></el-option>
                <el-option label="港口" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="备注" prop="remarks">
              <el-input v-model="dialogData.remarks" placeholder="请输入备注-路线"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="resetHandler" size="small" style="float: left">重置</el-button>
        <el-button @click="cancelHandler" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHandler" size="small">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import BASE_API from '@/api/dataBase';
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  import PROJECTAPI from '@/api/intermodality/project';
  import API from '@/api/intermodality/haulingTrack';
  export default {
    name: 'EditRouteDialog',
    mixins: [IntermodalityCommonMixin],
    data() {
      return {
        rules: {},
        dialogVisible: false,
        routeNameEdited: false,
        ifCreateNewRoute: false,
        provinceList: [],
        departureCityList: [],
        departureAreaList: [],
        destinationCityList: [],
        destinationAreaList: [],
        dialogData: {
          routeCode: null,
          routeName: null,
          departurePlaceName: null,
          departurePlaceDetail: null,
          departurePlaceType: null,
          destinationName: null,
          destinationDetail: null,
          destinationType: null,
          remarks: null,
          departureProvinceCode: null,
          departureCityCode: null,
          departureAreaCode: null,
          destinationProvinceCode: null,
          destinationCityCode: null,
          destinationAreaCode: null,
          //逗号拼接的省市区code
          departurePlaceCode: null,
          destinationCode: null,
          xid: null,
        },
        isEditModal: false,
      };
    },
    mounted() {
      this.initLocationData();
    },
    methods: {
      async getCurrentRouteDetail(code) {
        const res = await this.$axios.post(PROJECTAPI.LIST_ROUTE, { code });
        return res.data;
      },
      async openModal(rowData = {}) {
        console.log('rowDtaa', rowData);
        this.dialogVisible = true;
        // await this.getRoutes();
        if (Object.keys(rowData).length) {
          this.isEditModal = true;
          for (let key in this.dialogData) {
            this.dialogData[key] = rowData[key];
          }
          this.dialogData.xid = rowData._XID;
          const routeData = await this.getCurrentRouteDetail(this.dialogData.routeCode);
          this.handleRouteChange(routeData.data);
        } else {
          this.isEditModal = false;
          for (let key in this.dialogData) {
            this.dialogData[key] = null;
          }
        }
        this.getRules();
      },
      resetHandler() {
        this.ifCreateNewRoute = false;
        for (let key in this.dialogData) {
          this.dialogData[key] = null;
        }
        this.clearList();
      },

      routeNameEdit(value) {
        console.log('edit route', value);
        this.routeNameEdited = true;
      },

      clearList() {
        this.departureCityList = [];
        this.departureAreaList = [];
        this.destinationCityList = [];
        this.destinationAreaList = [];
        this.ifCreateNewRoute = false;
        this.rules = {};
        this.routeNameEdited = false;
      },

      cancelHandler() {
        for (let key in this.dialogData) {
          this.dialogData[key] = null;
        }
        this.dialogVisible = false;
        this.ifCreateNewRoute = false;
        this.$refs.dialogForm.resetFields();
        this.clearList();
      },
      placeChange(type, value) {
        this.ifCreateNewRoute = true;
        console.log(type, value);
      },
      getRules() {
        var requireDepartureCity = true;
        var requireDepartureArea = true;
        if (!this.departureCityList || this.departureCityList.length == 0) {
          requireDepartureCity = false;
        }
        if (!this.departureAreaList || this.departureAreaList.length == 0) {
          requireDepartureArea = false;
        }

        var requireDestinationCity = true;
        var requireDestinationArea = true;
        if (!this.destinationCityList || this.destinationCityList.length == 0) {
          requireDestinationCity = false;
        }
        if (!this.destinationAreaList || this.destinationAreaList.length == 0) {
          requireDestinationArea = false;
        }

        console.log(requireDepartureArea, requireDestinationArea);
        this.rules = {
          routeName: [{ required: true, message: '请选择路线', trigger: ['blur', 'change'] }],
          departureProvinceCode: [
            { required: true, message: '请选择省', trigger: ['blur', 'change'] },
          ],
          departureCityCode: [{ required: requireDepartureCity, message: '请选择市' }],
          // departureAreaCode: [{ required: requireDepartureArea, message: '请选择区' }],
          destinationProvinceCode: [
            { required: true, message: '请选择省', trigger: ['blur', 'change'] },
          ],
          destinationCityCode: [{ required: requireDestinationCity, message: '请选择市' }],
          // destinationAreaCode: [{ required: requireDestinationArea, message: '请选择区' }],
          // departurePlaceType: [
          //   { required: true, message: '请选择启运位置类型', trigger: ['blur', 'change'] },
          // ],
          // destinationType: [{ required: true, message: '请选择目的位置类型' }],
        };
        this.$nextTick(() => {
          this.$refs.dialogForm.clearValidate();
        });
      },
      resetLocation(num) {
        console.log('resetLocation', num);
        switch (num) {
          case 0:
            //重置启运市县
            this.dialogData.departureCityCode = null;
            this.dialogData.departureAreaCode = null;
            break;
          case 1:
            //重置启运县
            this.dialogData.departureAreaCode = null;
            break;
          case 2:
            //重置目的市县
            this.dialogData.destinationCityCode = null;
            this.dialogData.destinationAreaCode = null;
            break;
          case 3:
            //重置目的县
            this.dialogData.destinationAreaCode = null;
            break;
        }
        //更改省市区就代表创建新路线
        this.ifCreateNewRoute = true;
        this.getRules();
      },

      passValues(fromMap, toMap) {
        for (let key in fromMap) {
          toMap[key] = fromMap[key];
        }
        return toMap;
      },
      // 校验名称是否重复
      async nameChange() {
        const params = {
          name: this.dialogData.routeName,
          id: (this.dialogData || {}).id || '',
        };
        if (params.name) {
          let res = await this.$axios.post(API.CHECK_NAME, params);
          if (res.data.code == 10000) {
            return res.data.msg;
          } else {
            return null;
          }
        }
      },
      async confirmHandler() {
        console.log('submit', this.dialogData);
        // 保存前进行线路名称校验,编辑时未修改弹窗不走校验
        if (this.ifCreateNewRoute) {
          let isRepeat = await this.nameChange();
          if (isRepeat) {
            return this.$message.error(isRepeat);
          }
        }

        let valid = await this.$refs.dialogForm.validate();
        if (!valid) {
          return;
        }

        let result = { ...this.dialogData };

        if (this.ifCreateNewRoute) {
          let routeName = this.dialogData.routeName;

          if (
            !routeName ||
            routeName.replace(/(^\s*)|(\s*$)/g, '').length == 0 ||
            !this.routeNameEdited
          ) {
            result = this.passValues(this.generateRouteNames(true), result);
          } else {
            result = this.passValues(this.generateRouteNames(), result);
          }
          //创建线路做拼接操作
          result = this.passValues(this.processCodeInfo(), result);
          var code = await this.generateNewRoute(this.dialogData);
          if (!code) {
            return;
          }
          result.routeCode = code;
          //获取路线名
        } else {
          result = this.passValues(this.processCodeInfo(), result);
          result = this.passValues(this.generateRouteNames(), result);
          //拼接省市区
        }

        this.$emit('confirmHandler', result, this.isEditModal);
        this.$nextTick(() => {
          this.cancelHandler();
        });
      },
      async handleRouteChange(val) {
        this.clearList();
        var route = val[0];
        if (!route) {
          this.$message.error('找不到该路线的信息');
          return;
        }
        console.log('selectedRoute', route);
        this.dialogData.routeCode = route.code;
        this.dialogData.routeName = route.name;
        this.dialogData.departureProvinceCode = route.beginProvinceNo;
        this.dialogData.departurePlaceDetail = route.beginDetailAddress;
        this.dialogData.departurePlaceType = route.beginType;
        this.dialogData.destinationProvinceCode = route.goalProvinceNo;
        this.dialogData.destinationDetail = route.goalDetailAddress;
        this.dialogData.destinationType = route.goalType;
        this.dialogData.remarks = route.remark;
        this.dialogData.departurePlaceCode = route.departurePlaceCode;
        this.dialogData.destinationCode = route.destinationCode;
        this.dialogData.departureCityCode = route.beginCityNo;

        if (route.beginProvinceNo) {
          await this.queryCity(route.beginProvinceNo);
          if (this.departureCityList && this.departureCityList.length) {
            this.dialogData.departureCityCode = route.beginCityNo;
          }
        }
        if (route.beginCityNo) {
          await this.queryArea(route.beginCityNo);
          if (this.departureAreaList && this.departureAreaList.length) {
            this.dialogData.departureAreaCode = route.beginAreaNo;
          }
        }

        if (route.goalProvinceNo) {
          await this.queryCity(route.goalProvinceNo, false);
          if (this.destinationCityList && this.destinationCityList.length) {
            this.dialogData.destinationCityCode = route.goalCityNo;
          }
        }

        if (route.goalAreaNo) {
          await this.queryArea(route.goalCityNo, false);
          if (this.destinationAreaList && this.destinationAreaList.length) {
            this.dialogData.destinationAreaCode = route.goalAreaNo;
          }
        }
        this.getRules();
      },
      processCodeInfo() {
        let codes = {};
        let departureCodeList = [];
        if (this.dialogData.departureProvinceCode) {
          departureCodeList.push(this.dialogData.departureProvinceCode);
        }
        if (this.dialogData.departureCityCode) {
          departureCodeList.push(this.dialogData.departureCityCode);
        }
        if (this.dialogData.departureAreaCode) {
          departureCodeList.push(this.dialogData.departureAreaCode);
        }
        codes.departurePlaceCode = departureCodeList.join(',');

        let destinationCodeList = [];
        if (this.dialogData.destinationProvinceCode) {
          destinationCodeList.push(this.dialogData.destinationProvinceCode);
        }
        if (this.dialogData.destinationCityCode) {
          destinationCodeList.push(this.dialogData.destinationCityCode);
        }
        if (this.dialogData.destinationAreaCode) {
          destinationCodeList.push(this.dialogData.destinationAreaCode);
        }
        codes.destinationCode = destinationCodeList.join(',');
        return codes;
      },
      generateRouteNames(concatRouteName = false) {
        let _self = this;
        let names = {};
        function getLabel(name, hasSuffix = false) {
          if (!_self.$refs[name]) {
            return '';
          }
          let item = _self.$refs[name];
          let buffer = '';
          if (item && item.selected && item.selected.label) {
            buffer += item.selected.label;
          }

          if (buffer.length == 0) {
            return '';
          }
          if (hasSuffix) {
            buffer += '-';
          }
          return buffer;
        }

        // let departurePlaceDetail = this.dialogData.departurePlaceDetail ?? '';
        // let destinationDetail = this.dialogData.destinationDetail ?? '';

        // let addSuffix = departurePlaceDetail.length && concatRouteName;

        names.departurePlaceName =
          getLabel('startProvinceRef') + getLabel('startCityRef') + getLabel('startAreaRef');
        names.destinationName =
          getLabel('endProvinceRef') + getLabel('endCityRef') + getLabel('endAreaRef');

        if (concatRouteName) {
          names.routeName = names.departurePlaceName + '-' + names.destinationName;
          console.log('routeNameCreated', names.routeName);
        }
        return names;
      },
      async initLocationData() {
        await this.queryProvince();
        //如果要加载编辑的数据这里还需要查询fixme
        // await this.queryCity();
      },
      async queryProvince() {
        this.provinceList = null;
        var res = await this.$axios.post(BASE_API.QUERY_PROVICE + '?parentAreaNo=CN', {});
        if (res.data.code === 0) {
          var result = res.data.data;
          this.provinceList = result;
          if (result && result.length > 0) {
            return result;
          }
        } else {
          this.$message({ showClose: true, message: res.data.msg, type: 'error' });
        }
        return null;
      },
      async queryCity(province, isDeparture = true) {
        var res = await this.$axios.post(BASE_API.QUERY_CITY + '?parentAreaNo=' + province, {});
        if (res.data.code === 0) {
          var result = res.data.data;
          if (isDeparture) {
            this.departureCityList = result;
          } else {
            this.destinationCityList = result;
          }
        } else {
          this.$message({ showClose: true, message: res.data.msg, type: 'error' });
        }
        return null;
      },
      async queryArea(city, isDeparture = true) {
        var res = await this.$axios.post(BASE_API.QUERY_AERA + '?parentAreaNo=' + city, {});
        var result = res.data.data;
        if (res.data.code === 0) {
          if (isDeparture) {
            this.departureAreaList = result;
          } else {
            this.destinationAreaList = result;
          }
        } else {
          this.$message({ showClose: true, message: res.data.msg, type: 'error' });
        }
        return null;
      },
    },
    computed: {
      getTitle() {
        if (this.isEditModal) {
          return '编辑路线';
        } else {
          return '新建路线';
        }
      },
    },
    watch: {
      ifCreateNewRoute: {
        deep: true,
        immediate: true,
        handler: function (newV, oldV) {
          if (newV !== oldV && newV) {
            this.dialogData = this.passValues(this.generateRouteNames(true), this.dialogData);
            this.$nextTick(() => {
              this.$refs.dialogForm.clearValidate();
            });
          } else {
            this.dialogData.routeName = null;
            this.dialogData.routeCode = null;
          }
        },
      },
    },
  };
</script>

<style lang="scss" scoped></style>
